// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"7d851edc","109":"621f56d3","277":"3094435e","381":"1a0166f0","473":"024ae9a4","543":"47881a83","594":"446d91ee","604":"2465aa05","775":"26865193","806":"2221072e"}[chunkId] + ".chunk.js";
};